import * as React from 'react';
import { Image } from '@cian/ui-kit/image';
import * as styles from './styles.css';
import { IGallery, IGallerySections } from '../../../types/gallery';
import { IMediaItem } from '../../../types/newbuilding/media';
import { IVideo } from '../../../types/video';
import { VideoPlayer } from '../../VideoPlayer';
import { VideoPreview } from '../../VideoPreview';
import { Category } from '../Category';

export interface IFullscreenGalleryContentProps {
  gallery: IGallery;
}

export function Content({ gallery }: IFullscreenGalleryContentProps) {
  return (
    <div className={styles['container']}>
      {gallery.map(category => (
        <div key={category.id} id={category.id} className={styles['category']}>
          <Category title={category.title}>
            {category.type === IGallerySections.Videos
              ? (category.media as IVideo[]).map(item => (
                  <div className={styles['image']} key={item.videoId}>
                    <VideoPlayer preview={<VideoPreview url={item.fullUrl} />} type={item.type} src={item.url} />
                  </div>
                ))
              : (category.media as IMediaItem[]).map((item, index) => (
                  <div className={styles['image']} key={item.id || index}>
                    <Image src={item.fullUrl} height="auto" width="100%" borderRadius="0" objectFit="contain" />
                  </div>
                ))}
          </Category>
        </div>
      ))}
    </div>
  );
}
